import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import Navbar from "../../Navbar";
import { guestSignupUrl } from "../../BaseURL";
import "../../styles/public.css";

export default function GuestSignup() {
  const navigate  = useNavigate();
  const location  = useLocation();
  // If the visitor was sent here mid-booking, bounce them back to /reserve
  // after sign-up so they can finish the flow seamlessly.
  const next      = location.state?.next || "/reserve";

  const [form,    setForm]    = useState({ full_name: "", email: "", phone: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [err,     setErr]     = useState("");

  const set = (k, v) => setForm((s) => ({ ...s, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      const res = await axios.post(guestSignupUrl, form);
      if (res.data?.success && res.data.guest) {
        localStorage.setItem("guest", JSON.stringify(res.data.guest));
        navigate(next, { replace: true });
      } else {
        setErr(res.data?.message || "Could not create your account.");
      }
    } catch (e) {
      setErr(e.response?.data?.message || "Could not create your account.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="pp-root">
      <div className="pp-bg" />
      <Navbar />
      <div className="pp-content">
        <div className="pp-page-head">
          <div className="pp-eyebrow">Guest Account</div>
          <h1 className="pp-h1"><em>Create</em> your account</h1>
          <p className="pp-tag">
            One account lets you reserve rooms, check booking status, and skip the front-desk paperwork on arrival.
          </p>
        </div>

        <form className="pp-form-card" onSubmit={submit}>
          {err && <div className="pp-error">{err}</div>}

          <div className="pp-field">
            <label className="pp-label">Full name</label>
            <input className="pp-input" required value={form.full_name}
                   onChange={(e) => set("full_name", e.target.value)}
                   placeholder="e.g. Kwame Mensah" />
          </div>

          <div className="pp-field">
            <label className="pp-label">Email</label>
            <input className="pp-input" type="email" required value={form.email}
                   onChange={(e) => set("email", e.target.value)}
                   placeholder="you@example.com" />
          </div>

          <div className="pp-field">
            <label className="pp-label">Phone (optional)</label>
            <input className="pp-input" value={form.phone}
                   onChange={(e) => set("phone", e.target.value)}
                   placeholder="+233 …" />
          </div>

          <div className="pp-field">
            <label className="pp-label">Password</label>
            <input className="pp-input" type="password" required minLength={6}
                   value={form.password}
                   onChange={(e) => set("password", e.target.value)}
                   placeholder="At least 6 characters" />
          </div>

          <button type="submit" className="pp-btn" disabled={loading}>
            {loading ? "Creating account…" : "Sign Up"}
          </button>

          <div className="pp-form-foot">
            Already have an account?{" "}
            <Link to="/guest/login" state={{ next }}>Sign in</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
